import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VAutocomplete,_vm._b({attrs:{"loading":_vm.loading,"items":_vm.selectableRfidTokens,"item-value":"id","item-text":"secret","return-object":!_vm.returnId,"clearable":_vm.clearable,"auto-select-first":""},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(item.id)+" – "+_vm._s(item.secret))]}}]),model:{value:(_vm.modified),callback:function ($$v) {_vm.modified=$$v},expression:"modified"}},'VAutocomplete',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }